export const PATH_SCALE = 5;
export const PATH_SCALE_FOCUS = 6;
export const PATH_ANCHOR = { x: 2.5, y: 2.5 };
export const BOUNDS_PADDING = 10;
